import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickHealthAssessmentModel } from 'src/app/shared/model/quick.health.assessment';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-ia-step-7',
  templateUrl: './ia-step-7.component.html',
  styleUrl: './ia-step-7.component.css'
})
export class IaStep7Component implements OnInit {

  assessment: QuickHealthAssessmentModel = new QuickHealthAssessmentModel();

  constructor(
    private userService: UserService,
    public router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder    
  ) { }

  ngOnInit(): void {
    const assessmentId = this.route.snapshot.paramMap.get('id');
    if(assessmentId) {
      this.userService.getQuickHealthAssessment(assessmentId).subscribe({
        next: (value) => {
          if(value) {            
            this.assessment = value;
          }          
        },
        error: (err) => {
          this.router.navigateByUrl("/intro-assessment/welcome"); 
        }
      })
    }
  }


  onChange() {

    const value = this.assessment;
    this.userService.saveQuickHealthAssessment(value).subscribe({
      next: (value) => {
          console.log("saveQuickHealthAssessment result: " + value);
      },
    });   
     
  }

  _prevButton() { 
    this.router.navigateByUrl("/intro-assessment/6/" + this.assessment.id);
 }

  _nextButton() {     
    this.router.navigateByUrl("/intro-assessment/8/" + this.assessment.id);
 }

}
